import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";

import { db, auth } from "../firebase/config";

// =========================================================
// PAYMENT COLLECTION
// =========================================================

const getPaymentCollection = () => {
  const uid = auth.currentUser?.uid;

  if (!uid) {
    throw new Error("User not authenticated");
  }

  return collection(db, "gyms", uid, "payments");
};

// =========================================================
// GET PAYMENTS
// =========================================================

export const getPayments = async () => {
  const snapshot = await getDocs(getPaymentCollection());

  return snapshot.docs.map((paymentDoc) => ({
    id: paymentDoc.id,
    ...paymentDoc.data(),
  }));
};

// =========================================================
// ADD PAYMENT
// =========================================================

export const addPayment = async (data) => {
  if (!data.memberId) {
    throw new Error("Member ID is required.");
  }

  if (!data.memberName) {
    throw new Error("Member name is required.");
  }

  if (!data.membershipPlan) {
    throw new Error("Membership plan is required.");
  }

  if (!data.amount || Number(data.amount) <= 0) {
    throw new Error("Valid payment amount is required.");
  }

  if (!data.paymentDate) {
    throw new Error("Payment date is required.");
  }

  if (!data.status) {
    throw new Error("Payment status is required.");
  }

  const paymentData = {
    memberId: data.memberId,
    memberName: data.memberName,
    membershipPlan: data.membershipPlan,
    amount: Number(data.amount),
    paymentDate: data.paymentDate,
    status: data.status,
    createdAt: data.createdAt || new Date().toISOString(),
  };

  return await addDoc(getPaymentCollection(), paymentData);
};

// =========================================================
// DELETE PAYMENT
// =========================================================

export const deletePayment = async (id) => {
  const uid = auth.currentUser?.uid;

  if (!uid) {
    throw new Error("User not authenticated");
  }

  if (!id) {
    throw new Error("Payment ID is required.");
  }

  await deleteDoc(doc(db, "gyms", uid, "payments", id));
};

// =========================================================
// UPDATE PAYMENT STATUS
// =========================================================

export const updatePaymentStatus = async (id, status) => {
  const uid = auth.currentUser?.uid;

  if (!uid) {
    throw new Error("User not authenticated");
  }

  if (!id) {
    throw new Error("Payment ID is required.");
  }

  if (!status) {
    throw new Error("Payment status is required.");
  }

  await updateDoc(doc(db, "gyms", uid, "payments", id), {
    status,
  });
};
